import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { IonSelect, IonSelectOption } from '@ionic/vue';
import SelectOption from '@/types/SelectOption';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownSelect',
  props: {
    modelValue: {},
    label: {},
    options: {},
    interface: { default: 'action-sheet' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const emitNewValue = (event: any) => {
  emit('update:modelValue', event.detail.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonSelect), {
    class: "dropdown-select",
    interface: _ctx.interface,
    placeholder: _ctx.label,
    "cancel-text": _ctx.$t('cancel'),
    onIonChange: emitNewValue,
    value: _ctx.modelValue
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
          value: option.value,
          key: `${_ctx.label}-options-${index}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.label), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["interface", "placeholder", "cancel-text", "value"]))
}
}

})